<template>
	<div class="container">
		<h2 class="heading-2 global-box-heading">{{ $t('globalRules') }}</h2>
		<ja-input
			:value="globalRulesData.systemName"
			disabled
			:label="$t('systemName')"
			:name="$t('systemName')"
			@blur="handleBlur"
		></ja-input>
		<ja-input
			v-model.trim="globalRulesData.name"
			:value="globalRulesData.name"
			:label="$t('displayName')"
			:name="$t('displayName')"
			@blur="handleBlur"
		></ja-input>
		<div>
			<h2 class="heading-5">{{ $t('shoppingType') }}</h2>
			<div class="container-input-checkbox">
				<div
					v-for="(option, index) in isRequiredData"
					:key="index"
					class="option"
				>
					<input
						ref="checkboxRequired"
						v-model="option.isActive"
						:name="option.name"
						type="checkbox"
						class="checkbox"
						@change="isRequiredCheck(index)"
						@blur="handleBlur"
					/>
					<label :for="option.name" class="body-text-2 input-label">
						{{ option.name }}
					</label>
				</div>
			</div>
		</div>
		<div>
			<h2 class="heading-5">{{ $t('billboardLogo') }}</h2>
			<div class="select-file">
				<ja-button
					name="selectFile"
					class="small outlined"
					@click.native="openFileSelector"
					>{{ $t('selectFile') }}</ja-button
				>
				<img
					v-show="globalRulesData.billboardLogoBase64"
					ref="imageLogo"
					:src="globalRulesData.billboardLogoBase64"
					:alt="'logo' + globalRulesData.name"
					class="thumbnail"
				/>
				<span v-show="!fileInfo">{{ $t('chooseALogo') }}</span>
				<input
					ref="fileInput"
					type="file"
					style="display: none;"
					accept=".png, .jpg, .jpeg"
					@change="validateFile"
				/>
			</div>
			<div v-show="fileInfo" class="select-file  selection">
				<div class="file-info">
					<span v-if="!fileValid" class="text--warning">{{
						$t('formatPNG')
					}}</span>
				</div>
			</div>
		</div>
		<div>
			<h2 class="heading-5">{{ $t('paymentOptions') }}</h2>
			<div class="container-input-checkbox">
				<div
					v-for="(option, index) in paymentsOptionsData"
					:key="index"
					class="option"
				>
					<input
						ref="checkboxPayment"
						v-model="option.isActive"
						:name="option.name"
						type="checkbox"
						class="checkbox"
						@change="paymentOptionCheck(index)"
						@blur="handleBlur"
					/>
					<label :for="option.name" class="body-text-2 input-label">
						{{ option.name }}
					</label>
				</div>
			</div>
		</div>
		<div>
			<h2 class="heading-5">{{ $t('availableIn') }}</h2>
			<div class="container-input-checkbox">
				<div
					v-for="(option, index) in lifeStageData"
					:key="index"
					class="option"
				>
					<input
						ref="checkboxSimulationType"
						v-model="option.isActive"
						:name="option.name"
						type="checkbox"
						class="checkbox"
						@change="simulationTypeCheck(index)"
						@blur="handleBlur"
					/>
					<label :for="option.name" class="body-text-2 input-label">
						{{ option.name }}
					</label>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { Input } from '@/components/ui/form';
import Button from '@/components/ui/Button';
import { lifeStageDropdown } from '@/helpers/constants';
import { ResizeImage } from '@/mixins';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';

export default {
	components: {
		jaInput: Input,
		jaButton: Button
	},
	mixins: [ResizeImage],
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			globalRulesData: null,
			isRequiredData: [
				{ name: 'Required', isRequired: true, isActive: false },
				{ name: 'Optional', isRequired: false, isActive: false }
			],
			lifeStageData: [],
			paymentsOptionsData: [],
			fileValid: false,
			fileInfo: null
		};
	},
	created() {
		this.globalRulesData = this.data;
		this.setInitialValues();
	},
	methods: {
		setInitialValues() {
			this.isRequiredData.forEach(sim => {
				sim.isActive = sim.isRequired === this.globalRulesData.isMandatory;
			});

			this.lifeStageData = lifeStageDropdown.map(lifeStage => ({
				...lifeStage,
				isActive: this.globalRulesData.selectedLifeStages.includes(
					lifeStage.lifeStage_ID
				)
			}));

			this.paymentsOptionsData = this.globalRulesData.upperPaymentMethods
				.filter(
					payment =>
						payment.upperPaymentMethod_ID === 1 ||
						payment.upperPaymentMethod_ID === 2
				)
				.map(payment => ({
					...payment,
					isActive: this.globalRulesData.selectedUpperPaymentMethods.includes(
						payment.upperPaymentMethod_ID
					)
				}));
		},
		paymentOptionCheck(index) {
			const checkPaymentOption = this.paymentsOptionsData[index];
			if (checkPaymentOption.isActive) {
				if (
					!this.globalRulesData.selectedUpperPaymentMethods.includes(
						checkPaymentOption.upperPaymentMethod_ID
					)
				) {
					this.globalRulesData.selectedUpperPaymentMethods.push(
						checkPaymentOption.upperPaymentMethod_ID
					);
				}
			} else {
				const indexToRemove = this.globalRulesData.selectedUpperPaymentMethods.indexOf(
					checkPaymentOption.upperPaymentMethod_ID
				);
				if (indexToRemove !== -1) {
					this.globalRulesData.selectedUpperPaymentMethods.splice(
						indexToRemove,
						1
					);
				}
			}
		},
		simulationTypeCheck(index) {
			const checkLifeStage = this.lifeStageData[index];
			if (checkLifeStage.isActive) {
				if (
					!this.globalRulesData.selectedLifeStages.includes(
						checkLifeStage.lifeStage_ID
					)
				) {
					this.globalRulesData.selectedLifeStages.push(
						checkLifeStage.lifeStage_ID
					);
				}
			} else {
				const indexToRemove = this.globalRulesData.selectedLifeStages.indexOf(
					checkLifeStage.lifeStage_ID
				);
				if (indexToRemove !== -1) {
					this.globalRulesData.selectedLifeStages.splice(indexToRemove, 1);
				}
			}
		},
		isRequiredCheck(index) {
			const checkboxRequired = this.$refs.checkboxRequired[index];

			this.isRequiredData.forEach((sim, i) => {
				sim.isActive = i === index;
			});

			if (
				checkboxRequired.checked === false &&
				this.isRequiredData[index].isActive == true
			) {
				this.$nextTick(() => {
					if (checkboxRequired) {
						checkboxRequired.checked = true;
					}
				});
				return;
			}
			this.globalRulesData.isMandatory = this.isRequiredData[index].isRequired;
		},
		async readFileAsync(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = () => {
					resolve(reader.result);
				};
				reader.onerror = reject;
				reader.readAsDataURL(file);
			});
		},
		openFileSelector() {
			this.$refs.fileInput.click();
		},
		async imageSize(file) {
			const maxLogoWidth = 165;
			const maxLogoHeight = 66;
			let fileDataURL = file;
			const resizedFile = await this.resizeImage(
				file,
				maxLogoWidth,
				maxLogoHeight
			);
			fileDataURL = await this.readFileAsync(resizedFile);

			return fileDataURL;
		},
		async validateFile(event) {
			const input = event.target;
			const file = input.files[0];
			const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg'];
			this.fileInfo = file.name;
			if (!allowedTypes.includes(file.type)) {
				this.fileValid = false;
				return;
			}

			const resizedDataURL = await this.imageSize(file);
			this.globalRulesData.billboardLogoBase64 = resizedDataURL;
			this.handleBlur();
			this.fileValid = true;
		},
		handleBlur() {
			this.$emit('globalRulesData', this.globalRulesData);
		}
	}
};
</script>
<style lang="scss" scoped>
.container {
	display: flex;
	flex-direction: column;
	gap: 20px;
}
.container-input-checkbox {
	border: 1px solid $button-border;
	display: flex;
	justify-content: flex-start;
	padding: 12px;
	margin-bottom: 25px;
	gap: 50px;
}
.option {
	display: flex;
	align-items: center;
	gap: 10px;
}
.file-info {
	display: flex;
	flex-direction: column;
	gap: 5px;
}

.input-label {
	cursor: pointer;
}
.select-file {
	display: flex;
	align-items: center;
	gap: 20px;
	margin: 10px 0 25px;
}
.selection {
	align-items: center;
}
.heading-5 {
	color: $font-dark;
	margin: 10px 0;
}
.thumbnail {
	width: 60px;
	height: auto;
	margin: 5px;
}
</style>
